export const isSubscriptionActive = (subscription) => {
  if (!subscription) return false;

  const { status, current_period_end } = subscription;
  const now = new Date();

  console.log(current_period_end, now);

  return ((status === "active") && new Date(current_period_end) > now);
};
